export class PiperingGroupModel {
    _id: string;
    id: number;
    name: string;
    code: string;
    isCold: boolean;

    constructor(_id = null,
        id = null,
        name = '',
        code = '',
        isCold = false
    ) {
        this._id = _id;
        this.id = id;
        this.name = name;
        this.code = code;
        this.isCold = isCold;
    }
}
